import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import moment from "moment";

import { VersionRow } from "components/BudgetBuilder/Versions/VersionsTable/VersionRow";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";


const VersionsTable = () => {
	const versions = useSelector(budgetBuilderSelectors.versions);

	const sortedVersions = useMemo(
		() => versions?.sort((a, b) => moment(b?.date).diff(moment(a?.date))),
		[ versions ],
	);

	return (
		<Table captionText="Versions">
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>{"Saved"}</Table.HeaderCell>
					<Table.HeaderCell>{"By"}</Table.HeaderCell>
					<Table.HeaderCell />
					<Table.HeaderCell>{"Note"}</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{sortedVersions?.map((version, key) => <VersionRow key={key} version={version} versions={versions} />)}
			</Table.Body>
		</Table>
	);
};

export default VersionsTable;
